import Vue from 'vue'
import Router from 'vue-router'
import order from '@/views/order'
import schedule from '@/views/schedule'
import history from '@/views/history'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'order',
      component: order
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: schedule
    },
    {
      path: '/history',
      name: 'history',
      component: history
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js